import { inject } from 'vue';
import { Capacitor, CapacitorHttp } from '@capacitor/core';
import { App as CapacitorApp } from '@capacitor/app';
import { Dialog } from '@capacitor/dialog';
import { compareVersions } from '../utils/versionCompare';
import store from 'root-js/store';

let hasCheckedMinimumIosVersion = false;

export function useMinimumIosVersionCheck() {

   
    const config = inject('$config');

    async function showUpdateDialog(currentVersion, minimumVersion) {
        await Dialog.alert({
            title: 'Update Required',
            message: `A newer version of the app is required to continue.\n\nCurrent version: ${currentVersion}\nRequired version: ${minimumVersion}`,
            buttonTitle: 'Update'
        });

        const appStoreUrl = config?.company?.app?.itunes?.url;
        if (appStoreUrl) {
            window.open(appStoreUrl, '_blank');
        }

        // Recursively call to prevent the user from bypassing the update
        setTimeout(() => {
            showUpdateDialog(currentVersion, minimumVersion);
        }, 500);
    }

    async function checkMinimumIosVersion() {

    


        if (hasCheckedMinimumIosVersion || Capacitor.getPlatform() !== 'ios') {
            return;
        }


        // return ;
        hasCheckedMinimumIosVersion = true;

        try {
            await store.dispatch('appConfig/FETCH_CONFIG');
            const minimumVersion = store.getters['appConfig/minimumIosVersion'];

            const appInfo = await CapacitorApp.getInfo();
            const currentVersion = appInfo?.version;

            if (minimumVersion && compareVersions(currentVersion, minimumVersion) < 0) {
                await showUpdateDialog(currentVersion, minimumVersion);
            } 
        } catch (error) {
            console.error('[app] minimum iOS version check failed completely', error);
        }
    }

    return { checkMinimumIosVersion };
}